import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2CalendarGenerateResponse,
  IIndirectTaxFilingV2CalendarParams,
  IIndirectTaxFilingV2MutationResult,
} from './types';

export async function generateIndirectTaxFilingV2Calendar({
  params,
  token,
}: {
  params: IIndirectTaxFilingV2CalendarParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2CalendarGenerateResponse>
> {
  try {
    const response = await fetcher(
      'new-sales-tax/filings-v2/calendar/generate',
      { method: 'POST', body: params },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to generate filing calendar',
      };
    }
    const data: IIndirectTaxFilingV2CalendarGenerateResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to generate filing calendar',
    };
  }
}
